require('../utils/jquery.matchHeight.js')

const matchHeight = {

    init(){

        jQuery( document ).ready(function($) {


                $('.product-text').matchHeight();
                $('.simple-slide').matchHeight();
                $('.post-slide').matchHeight();
                $('.post-slide img').matchHeight();
                $('.image-wrap').matchHeight();
                $('.post-slide .post-content').matchHeight();
                $('.post-words').matchHeight();
                $('.grid-item-content').matchHeight();
                $('.card').matchHeight();
                $('.card-text').matchHeight();




        })
    }


}

export default matchHeight;